import React from "react";
import "./styles/ProgressBar.scss";

const ProgressBar = ({
  value = 0,
  duration = 0,
  isLive = false,
  onChange,
  classNames = "",
}) => {
  const progressPercent = duration > 0 ? (value / duration) * 100 : 0;

  const handleClick = (e) => {
    if (isLive || !onChange || !duration) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const x = Math.max(0, Math.min(e.clientX - rect.left, rect.width));
    const newTime = (x / rect.width) * duration;
    onChange(Math.max(0, Math.min(newTime, duration)));
  };

  return (
    <div
      className={`custom-progress-bar ${classNames} ${isLive ? "live" : ""}`}
      onClick={handleClick}
    >
      <div className="progress-bar-track">
        <div
          className="progress-bar-fill"
          style={isLive ? { width: "100%" } : { width: `${progressPercent}%` }}
        >
          <div className="progress-handle"></div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ProgressBar);
